export function GeneralElections2020Template(params) {
  var district87Template = "";
  if (parseInt(params["State Rep Dist 87 Votes"]) > 0) {
    district87Template = `
        <table class="esri-widget__table">
            <thead>
                <tr>
                    <th class="header" colspan="2">State Representative District 87 Results</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th class="third">Candidate Name</th>
                    <td class="two-third">{State Rep Dist 87 Candidate Name}</td>
                </tr>
                <tr>
                    <th class="third">Votes Cast</th>
                    <td class="two-third">{State Rep Dist 87 Votes}</td>
                </tr>
            </tbody>
        </table>
        `;
  }

  var html = `
    <table class="esri-widget__table">
        <tbody>
            <tr>
                <th class="third">Precinct Name</th>
                <td class="two-third">{Precinct Name}</td>
            </tr>
            <tr>
                <th class="third">Polling Location</th>
                <td class="two-third">{Polling Location}</td>
            </tr>
            <tr>
                <th class="third">Polling Address</th>
                <td class="two-third">{Polling Address}</td>
            </tr>
            <tr>
                <th class="third">Registered Voters</th>
                <td class="two-third">{Registered Voters}</td>
            </tr>
        </tbody>
    </table>
    <div class="ui divider"></div>
    <table class="esri-widget__table">
        <thead>
            <tr>
                <th class="header" colspan="2">Presidential Results</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th class="third">Candidate Names</th>
                <td class="two-third">{Presidential Candidate Name}</td>
            </tr>
            <tr>
                <th class="third">Party</th>
                <td class="two-third">{Presidential Party}</td>
            </tr>
            <tr>
                <th class="third">Votes Cast</th>
                <td class="two-third">{Pesidential Votes Cast}</td>
            </tr>
        </tbody>
    </table>
    <table class="esri-widget__table">
        <thead>
            <tr>
                <th class="header" colspan="2">US Senator Results</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th class="third">Candidate Name</th>
                <td class="two-third">{US Senator Candidate Name}</td>
            </tr>
            <tr>
                <th class="third">Votes Cast</th>
                <td class="two-third">{US Senator Votes Cast}</td>
            </tr>
        </tbody>
    </table>
    <table class="esri-widget__table">
        <thead>
            <tr>
                <th class="header" colspan="2">US Representive District 2</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th class="third">Candidate Name</th>
                <td class="two-third">{US Rep Dist 2 Candidate Name}</td>
            </tr>
            <tr>
                <th class="third">Votes Cast</th>
                <td class="two-third">{US Rep Dist 2 Votes Cast}</td>
            </tr>
        </tbody>
    </table>
    <table class="esri-widget__table">
        <thead>
            <tr>
                <th class="header" colspan="2">State Senator Distict 44 Results</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th class="third">Candidate Name</th>
                <td class="two-third">{State Senator Dist 44 Candidate Name}</td>
            </tr>
            <tr>
                <th class="third">Votes Cast</th>
                <td class="two-third">{State Senator Dist 44 Votes Cast}</td>
            </tr>
        </tbody>
    </table>
    ${district87Template}
    `;

{/* <div class="ui divider"></div>
    <a target="_blank" href="https://www.dmcgis.com/map" target="_blank" class="ui fluid tiny button">View Detailed Report</a> */}

  return html;
}
